import { TFunction } from "i18next";

import {
  GROUPING_RULES_BY_PROCESS,
  type ImpactedOptimization,
  OptimizationTypeSchema,
} from "shared";

const joinParts = (parts: Array<string | null | undefined>) => parts.filter(Boolean).join(" · ");

const isSheetNesting = (optimization: ImpactedOptimization) =>
  optimization.type === OptimizationTypeSchema.enum.SHEET_NESTING;

export const getImpactedOptimizationTitle = (optimization: ImpactedOptimization, t: TFunction) => {
  if (isSheetNesting(optimization)) {
    return t("optimizations.card.title", { count: optimization.lineCount });
  }
  return t("optimizations.card.machineTimesTitle", {
    count: optimization.lineCount,
    process: optimization.industrialProcess
      ? t(`industrialProcesses.${optimization.industrialProcess}`)
      : "",
  });
};

export const getImpactedOptimizationSubtitle = (
  optimization: ImpactedOptimization,
  t: TFunction,
) => {
  const thickness =
    optimization.height === null
      ? null
      : t("optimizations.card.thickness", { height: optimization.height });

  if (isSheetNesting(optimization)) {
    return joinParts([t("optimizations.card.sheet"), optimization.materialName, thickness]);
  }

  const grouping = optimization.industrialProcess
    ? GROUPING_RULES_BY_PROCESS[optimization.industrialProcess]
    : null;
  if (!grouping || grouping === "allLines") {
    return "";
  }
  return joinParts([optimization.materialName, grouping === "material" ? null : thickness]);
};
